<template>
    <div>
        <ComHankkeet></ComHankkeet>
    </div>
</template>

<script lang="ts">
export default {
    name: "EtusivuView",
}
</script>

<script setup lang="ts">
import ComHankkeet from "@/components/etusivu/ComHankkeet.vue"

</script>
